import { create } from "zustand";

interface State {
    render: boolean;
    renderStore: () => void;
}

export const renderUiStore = create<State>()((set) => ({
    render: false,
    renderStore: () => set((state) => ({ render: !state.render })),
}));